import * as React from 'react';
import PropTypes from 'prop-types';

const ErrorMessage = ({error, onClose}) => {     
    return (
        error && error.length ? 
            <div className="alert alert-danger">
                {
                    onClose ?
                        <button type="button" className="close" onClick={onClose}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    : null
                }
                {
                    error.startsWith('["') ?
                        <ul>
                            {
                                JSON.parse(error).map((e, i) => <li key={i}>{e}</li>)
                            }
                        </ul>
                        :
                        error
                }            
            </div>   
            : null
    );
};

ErrorMessage.propTypes = {
    error: PropTypes.string,
    onClose: PropTypes.func
};

export default ErrorMessage;